export const prodConfig = {
  production: true,
  env: 'production',
  SERVER_ADDR: 'https://api.pixelone.app/ems/',
  TRACK_SERVER_ADDR: 'https://api.pixelone.app/public/',
  ADMIN_SERVER_ADDR: 'https://api.pixelone.app/admin/',
  ANALYTICS_SERVER_ADDR: 'https://api.pixelone.app/analytics/',
  SUB_URI_V2: 'api/v2/',
  VERSION: '1.0.0.211231',
  TOOLBAR_COLOR: 'primary',
  SHOPIFY_FLOW: 'manual',
  STRIPE_PUBLISHABLE_KEY:
    'pk_live_51NcENzH7ijxCcBHibtqZoSNTe5mTjSDPKkFszgtanwzfKV6I6Br7YwYkumlPvSCYp7KzYVbvh3hWVVYzqcmZgAbP00H1ghblIu',
  NEXT_PUBLIC_POS_INSTALLER_URL:
    'https://storage.googleapis.com/YOUR_BUCKET_NAME/downloads/PixelOne%20POS%20Setup%200.1.0.exe',
}
